'use strict';

/*

 =======
 REQUEST:
 =======

 ========
 RESPONSE:
 ========


 */
import {RunConfigService} from '@nuskin/ns-util';
import {utilModule} from '../module.js';

utilModule.factory('nsServerValidateService', ['$resource', function($resource) {
    //remember to put it back to the CQ
    //return $resource(ShopServiceApiVersion.getPostalCodeServiceVersionedUrl(
    // nuskin.configuration.checkout.postalCodeServiceUrl
    // ));
    return $resource(RunConfigService.getSiteUrl + '/' + 'apps/global/services/validationRule');
}]);

